import { reportFrontEndError } from "@/api/assine";
import cookies from "@/utils/cookies";
import Apm from "./Apm";

let timeout_apm;
let logs_apm = [];

let Log= {
    active: false,

    list: {
        warn:[],
        error:[],
        log:[],
        table:[],
    },

    css: [],

    warn: function(){
        if(Log.active){
            let arguments_array = Array.from(arguments);
            arguments_array.unshift('[ASSINE]');
            let log = Function.prototype.bind.call(console.warn, console);
            log.apply(this,arguments_array);
        }
    },

    log: function() {
        if(Log.active) {
            let arguments_array = Array.from(arguments);
            //@ts-igonre
            let isChrome = typeof window !== "undefined" && /Chrome/.test(navigator.userAgent);
            if (isChrome) {
                this.css.unshift('color: #005f93;font-weight: bold;font-size: 14px');
                arguments_array.unshift(this.css.join(';'));
                arguments_array.unshift('%c[ASSINE] %s');
            } else {
                arguments_array.unshift('[ASSINE]');
            }

            let log = Function.prototype.bind.call(console.log, console);
            log.apply(this, arguments_array);
            this.css = [];
        }
    },

    sendApm: function(log){

        logs_apm.push(log);

        clearTimeout(timeout_apm);

        timeout_apm = setTimeout(() => {

            let user = null;

            try{
                let oesp_info = cookies.get("OESP_INFO");
                if(oesp_info){
                    user = JSON.parse(oesp_info);
                }
            }catch (e){}

            reportFrontEndError({
                user: user ? {
                    id: user?.id,
                    email: user?.email
                } : null,
                url: typeof window !== "undefined" ? window.location.href : "",
                errors: logs_apm
            }).catch((err) => Apm.captureError(err))
            logs_apm = [];
        },200);
    }
};

export default Log;